<div class="tratamiento-datos">
    <div>
        <h3 class="sub-title">AVISO DE PRIVACIDAD</h3>
    </div>
    <div>
        <section class="title">
            <span>TRATAMIENTO DE DATOS PERSONALES</span>
        </section>
        <section class="content" >
            <p>
                Declaro que he sido informado que la U.A.E DIAN es responsable del tratamiento de mis datos personales obtenidos a
                través del diligenciamiento de los diferentes formatos, formularios o registros dispuestos en los sistemas
                informáticos, para el cumplimiento de las obligaciones tributarias, aduaneras y/o cambiarias, así como de los datos
                reportados por terceros.
            </p>
            <p>
                Igualmente, manifiesto que he leído la política de tratamiento de datos de la U.A.E DIAN, publicada en la página web
                <a class="link" target="_blank" href="https://www.dian.gov.co/normatividad/Normatividad/Circular-000001-de-25-01-2019.pdf">Ver</a>
            </p>
            <p>
                La U.A.E DIAN me ha informado que mis datos personales son recolectados, almacenados y usados con la finalidad de dar
                cumplimiento a su misión institucional, ejercer las actividades propias de las funciones de la Entidad y garantizar
                el cumplimiento de las obligaciones tributarias, aduaneras y/o cambiarias; además de desarrollar y gestionar los
                sistemas de información, servicios ciudadanos digitales, la administración de usuarios, la administración de
                infraestructura tecnológica y la seguridad informática.
            </p>
            <p>
                Entiendo que como titular de la información, de conformidad con lo establecido en el artículo 15 de la Constitución
                Política, tengo derecho a conocer, actualizar y rectificar mis datos personales, solicitar prueba de la autorización
                otorgada para su tratamiento, ser informado sobre el uso que se ha dado a los mismos y presentar quejas ante la
                Superintendencia de Industria y Comercio por infracción a la ley; asimismo, presentar observaciones, consultas,
                reclamos, revocar la autorización y/o solicitar la supresión de mis datos en los casos en que sea procedente, acceder
                en forma gratuita a los mismos; y formular las consultas y reclamos en los canales del Sistema de Peticiones, Quejas,
                Sugerencias, Reclamos, y Denuncias de la U.A.E DIAN (PQSRD), habilitados conforme lo establece la política de
                tratamiento de datos.
            </p>
            <p>
                De conformidad con lo previsto en las normas sobre protección de datos personales, especialmente lo consagrado en el
                artículo 10 de la Ley 1581 de 2012 y sus decretos reglamentarios, entiendo que la U.A.E DIAN:
            </p>
        </section>
        <section class="content">
            <ol>
                <li>No requiere autorización del titular cuando recolecta datos en el ejercicio de sus funciones </li>
                <li>Puede realizar el tratamiento de mis datos personales consignados en este sistema informático </li>
                <li>
                    Puede compartir información que contenga datos personales con otras entidades públicas o administrativas en
                    ejercicio de sus funciones legales o por orden judicial, dando cumplimiento a los requisitos y condiciones
                    establecidas en la Ley y la jurisprudencia para acceder a los mismos.
                </li>
            </ol>
        </section>
    </div>
</div>
